import(/* webpackMode: "eager" */ "/home/foneorders.com/app/src/app/(landing)/faq/page.tsx");
